import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';
import { setError } from './setError';

export function dateRangeValidator(startName: string, endName: string): ValidatorFn {
    return (group: AbstractControl): ValidationErrors | null => {
        const controlStart = group.get(startName);
        const start = controlStart?.value;
        const controlEnd = group.get(endName);
        const end = controlEnd?.value;

        if (start && end && end < start) {
            const error = { dateRange: true };
            setError(controlStart, error, 'dateRange');
            setError(controlEnd, error, 'dateRange');
            return error;
        } else {
            if (controlStart?.hasError('dateRange')) {
                setError(controlStart, null, 'dateRange');
            }
            if (controlEnd?.hasError('dateRange')) {
                setError(controlEnd, null, 'dateRange');
            }
        }

        return null;
    }
}
